import React from "react";

import { Transforms } from "slate";
import { Button } from "react-bootstrap";
import {
  ReactEditor,
  useFocused,
  useSelected,
  useSlateStatic,
} from "slate-react";

const Image = ({ attributes, children, element }) => {
  const focused = useFocused();
  const selected = useSelected();
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);

  const active = focused && selected;

  return (
    <div {...attributes}>
      {children}
      <div contentEditable={false} className={`position-relative`}>
        <img
          alt="uploaded"
          src={element.url}
          className={`img-fluid max-height-400 d-block z-0 ${
            active
              ? "border border-info border-opacity-50 border-3 rounded-2"
              : ""
          }`}
        />
        <Button
          variant="light"
          onClick={() => {
            Transforms.removeNodes(editor, { at: path });
          }}
          className={`position-absolute top-0 start-0 m-2 z-1 shadow-sm ${
            active ? "opacity-100" : "opacity-0"
          }`}
        >
          <span translate="no" className="material-symbols-outlined md-16">
            delete
          </span>
        </Button>
      </div>
    </div>
  );
};

export default Image;
